import React from 'react';
import { Link } from 'react-router-dom';
import { getPosUsername } from '../pages/POSLoginPage';

const IconWrench = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const IconChart = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);
const IconDocuments = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);
const IconCash = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);
const IconCreditCard = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
  </svg>
);
const IconEndDay = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const IconUser = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);
const IconLogout = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
  </svg>
);
const IconFeedback = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
  </svg>
);
const IconChevron = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);
const IconSettings = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
  </svg>
);
const IconFullscreen = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
  </svg>
);
const IconPower = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
);

export default function POSMenu({ open, onToggle, onLogout, onCashInOut, onEndOfDay, onUserInfo }) {
  const username = getPosUsername();
  const displayName = username.charAt(0).toUpperCase() + username.slice(1);

  const menuItem = (icon, label, href, onClick) => {
    const content = (
      <>
        <span className="text-gray-400">{icon}</span>
        <span>{label}</span>
      </>
    );
    if (onClick) {
      return (
        <button
          key={label}
          type="button"
          onClick={() => { onToggle?.(); onClick(); }}
          className="flex items-center gap-3 w-full px-3 py-2.5 text-left text-gray-300 hover:bg-gray-700 hover:text-white rounded text-sm transition-colors cursor-pointer"
        >
          {content}
        </button>
      );
    }
    if (href) {
      return (
        <Link
          key={label}
          to={href}
          onClick={() => onToggle?.()}
          className="flex items-center gap-3 w-full px-3 py-2.5 text-left text-gray-300 hover:bg-gray-700 hover:text-white rounded text-sm transition-colors cursor-pointer"
        >
          {content}
        </Link>
      );
    }
    return (
      <button
        key={label}
        type="button"
        className="flex items-center gap-3 w-full px-3 py-2.5 text-left text-gray-400 rounded text-sm cursor-default"
      >
        {content}
      </button>
    );
  };

  return (
    <>
      {/* Toggle button - always visible */}
      <button
        type="button"
        onClick={onToggle}
        className="p-2 text-gray-400 hover:text-white rounded-lg border border-gray-600 hover:bg-gray-700"
        title="POS Menu"
        aria-label="Toggle POS menu"
      >
        <IconWrench className="w-5 h-5" />
      </button>

      {/* Sidebar overlay when open - behind sidebar, click to close */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-[60] lg:hidden"
          onClick={onToggle}
          aria-hidden="true"
        />
      )}

      {/* Sidebar - high z-index and pointer-events to ensure clicks work */}
      <aside
        onClick={(e) => e.stopPropagation()}
        className={`fixed top-0 right-0 h-full w-72 bg-gray-900 border-l border-gray-700 z-[70] flex flex-col transform transition-transform duration-200 ease-out pointer-events-auto ${
          open ? 'translate-x-0' : 'translate-x-full pointer-events-none'
        }`}
        style={{ isolation: 'isolate' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h2 className="font-semibold text-white truncate">POS - {displayName}</h2>
          <button
            type="button"
            onClick={onToggle}
            className="p-1.5 text-gray-400 hover:text-white rounded"
            aria-label="Close menu"
          >
            <IconChevron className="w-5 h-5 rotate-180" />
          </button>
        </div>

        {/* Management */}
        <div className="px-3 py-2">
          <Link
            to="/admin"
            onClick={() => onToggle?.()}
            className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-gray-400 hover:text-white uppercase tracking-wider cursor-pointer hover:bg-gray-700 rounded transition-colors"
          >
            <IconWrench className="w-4 h-4" /> Management
          </Link>
          <div className="mt-1 space-y-0.5">
            {menuItem(<IconChart />, 'View sales history', '/reports?tab=sales')}
            {menuItem(<IconDocuments />, 'View open sales', '/reports')}
            {menuItem(<IconCash />, 'Cash In / Out', null, onCashInOut || (() => {}))}
            {menuItem(<IconCreditCard />, 'Credit payments', null, () => {})}
            {menuItem(<IconEndDay />, 'End of day', null, onEndOfDay || (() => {}))}
          </div>
        </div>

        {/* User */}
        <div className="px-3 py-2 border-t border-gray-700">
          <p className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-gray-500 uppercase tracking-wider">
            <IconUser className="w-4 h-4" /> User
          </p>
          <div className="mt-1 space-y-0.5">
            {menuItem(<IconUser />, 'User info', null, onUserInfo || (() => {}))}
            {menuItem(<IconLogout />, 'Sign out', null, onLogout)}
            {menuItem(<IconFeedback />, 'Feedback', null, () => {})}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-auto p-4 border-t border-gray-700">
          <p className="text-xs text-gray-500 mb-3">{new Date().toLocaleDateString()}</p>
          <div className="flex gap-2">
            <button type="button" className="p-2 text-gray-400 hover:text-white rounded" title="Settings">
              <IconSettings />
            </button>
            <button
              type="button"
              className="p-2 text-gray-400 hover:text-white rounded"
              title="Fullscreen"
              onClick={() => document.documentElement.requestFullscreen?.()}
            >
              <IconFullscreen />
            </button>
            <button type="button" className="p-2 text-gray-400 hover:text-white rounded" title="Power" onClick={onLogout}>
              <IconPower />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
